import * as Sentry from "@sentry/react";
import { useRouteError } from "react-router-dom";

const RouterErrorBoundary = () => {
  const error = useRouteError();

  Sentry.captureException(error);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <h1 className="text-2xl font-bold text-red-600 mb-4">
          Ops! Algo deu errado
        </h1>
        <p className="text-gray-600 mb-4">
          Desculpe, ocorreu um erro inesperado. Nossa equipe foi notificada e
          está trabalhando para resolver.
        </p>
        <div className="space-y-4">
          <button
            onClick={() => window.location.reload()}
            className="w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition-colors"
          >
            Recarregar página
          </button>
        </div>
      </div>
    </div>
  );
};

export default RouterErrorBoundary;
